export const GlobalEvents = {
  setRequestParams: 'globalEvents/setRequestParams',
  setRequestID: 'globalEvents/setRequestID',
  setUserAgent: 'globalEvents/userAgent',
  setIsBot: 'globalEvents/isBot',
} as const;
